<template>
  <div
    class="ContentHomeSliderItem pattern-slider-item"
  >
    <svg
      width="560"
      height="580"
      viewBox="0 0 560 580"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      class="pattern-slider-item__svg"
    >
      <mask
        :id="`mask0_388_7542-2-${id}`"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="560"
        height="580"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          :d="tablet ? MOBILE_MASK_PATH : DESKTOP_MASK_PATH"
          fill="#D9D9D9"
        />
      </mask>
      <g :mask="`url(#mask0_388_7542-2-${id}`">
        <rect
          :width="tablet ? '400' : '560'"
          :height="tablet ? '450' : '580'"
          :fill="`url(#pattern0-${id})`"
        />
      </g>
      <defs>
        <pattern
          :id="`pattern0-${id}`"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
          class="pattern-use"
          :style="{ '--transform-scale': `scale(1.${scale})` }"
          :class="{ 'is--safari': safari }"
        >
          <use
            :xlink:href="`#image0_388_7542-${id}`"
            :transform="tablet ? `translate(0.01 0) scale(0.0012)` : `translate(0 0) scale(0.0014)`"
          />
        </pattern>
        <image
          :id="`image0_388_7542-${id}`"
          class="pattern-slider-item__image"
          width="660"
          height="680"
          :href="imagePath"
          :transform-origin="tablet ? '150 150' : '200 200'"
        />
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import { DESKTOP_MASK_PATH, MOBILE_MASK_PATH } from '../const/pattern-path';

export default defineComponent({
  name: 'ContentHomeSliderItem',
  props: {
    imagePath: String,
    id: Number,
    tablet: Boolean,
    safari: Boolean,
  },
  setup() {
    let intervalId = 0;
    const scale = ref(300);

    function init() {
      scale.value = 300;
      let count = 300;
      intervalId = setInterval(() => {
        count -= 1;
        scale.value = count;
      }, 55);
    }

    onMounted(() => {
      init();
    });

    onBeforeUnmount(() => {
      clearInterval(intervalId);
    });

    return {
      scale,
      DESKTOP_MASK_PATH,
      MOBILE_MASK_PATH,
    };
  },
});
</script>
<style lang="sass" scoped>
@import '~Styles/_variables'
.pattern-use
  &.is--safari
    backface-visibility: hidden !important
    -webkit-backface-visibility: hidden
    will-change: transform
    transform: var(--transform-scale)
    -webkit-transform: var(--transform-scale)
.pattern-slider-item
  position: relative
  z-index: 1
  width: 100%
  height: 540px
  backface-visibility: hidden !important
  -webkit-backface-visibility: hidden
  -webkit-transform: translate3d(0, 0, 0)
  &__image
    backface-visibility: hidden !important
    -webkit-backface-visibility: hidden
    will-change: transform
    transform: var(--transform-scale)
    -webkit-transform: var(--transform-scale)
  &__svg
    @media screen and (max-width: 375px)
      width: 550px
    @media screen and (max-width: 320px)
      width: 460px
</style>
